import { useEffect, useState } from 'react';
import { ChevronDown, Plus } from 'lucide-react';
import { Button } from '../ui/button';

export const CustomerSiteGroup = ({ group, canManage, saving, onAdd, children }) => {
  const [expanded, setExpanded] = useState(true);
  useEffect(() => { setExpanded(true); }, [group.sites.length]);
  const id = encodeURIComponent(group.key);
  return (
    <section className="py-3 min-w-0" data-testid={`customer-site-group-${id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <button type="button" className="flex flex-1 min-w-0 items-start gap-2 text-sm font-semibold text-slate-900 text-left" onClick={() => setExpanded((v) => !v)} aria-expanded={expanded} aria-controls={`site-group-rows-${id}`} data-testid={`customer-site-group-toggle-${id}`}>
          <ChevronDown size={14} className={`shrink-0 mt-0.5 transition-transform ${expanded ? '' : '-rotate-90'}`} />
          <span className="min-w-0 break-words">{group.name || 'Unassigned LSDs'}<span className="ml-2 text-xs font-normal text-slate-500" data-testid={`customer-site-group-count-${id}`}>{group.lsdCount} LSD{group.lsdCount === 1 ? '' : 's'}{group.addressCount > 0 ? ` · ${group.addressCount} address${group.addressCount === 1 ? '' : 'es'}` : ''}</span></span>
        </button>
        {canManage && group.name && <Button type="button" variant="ghost" size="sm" className="text-xs shrink-0" disabled={saving} onClick={() => onAdd(group.name)} data-testid={`customer-site-add-location-${id}`}><Plus size={14} className="mr-1.5" />Add new LSD/address</Button>}
      </div>
      <ul id={`site-group-rows-${id}`} hidden={!expanded} className="divide-y divide-slate-100 mt-1">{children}</ul>
    </section>
  );
};